import { Microfrontend } from '@cian/mf-react';
import { IMicrofrontendManifest } from '@cian/mf-registry/shared';
import * as React from 'react';

import { ComplainsModalLoader } from '../ComplainsModalLoader';
import { ModalComplainsLoadError } from '../ModalComplainsLoadError';
import { useModerationComplaint } from '../hoock';

type ComplaintModalContentProps = {
  offerId: number;
  isError: boolean;
  manifest: IMicrofrontendManifest | null;
  openModal: boolean;

  onCloseModal(): void;
  getComplaints(): void;
};

export const ComplaintModalContent: React.FC<ComplaintModalContentProps> = ({
  onCloseModal,
  offerId,
  manifest,
  isError,
  getComplaints,
}) => {
  const { isLoading, refetch } = useModerationComplaint({ onCloseModal, getComplaints });

  if (isError) {
    return <ModalComplainsLoadError isLoading={isLoading} refetch={refetch} />;
  }

  if (!manifest) {
    return <ComplainsModalLoader />;
  }

  return (
    <Microfrontend
      image={manifest.imageVersion}
      name={manifest.microfrontendName}
      parameters={{ offerId }}
      runtime={manifest.runtimeName}
    />
  );
};
